
import { useTranslation } from 'react-i18next';
import UI from '../UI';
import useLocale from '../useLocale';

export interface PriceRangeProps {
  prices: Price[];
  units?: number;
}

interface Price {
  amount: number;
  current_amount?: number;
}

const PriceRange = ({ prices, units = 1 }: PriceRangeProps) => {
  const { t } = useTranslation('common');
  const { formatCurrency } = useLocale();

  let min: number | null = null;
  let max: number | null = null;
  let currentMin: number | null = null;
  let currentMax: number | null = null;

  prices.forEach((promotion) => {
    if (min === null) {
      min = promotion.amount * units;
      max = promotion.amount * units;
      currentMin = (promotion.current_amount ?? promotion.amount) * units;
      currentMax = (promotion.current_amount ?? promotion.amount) * units;
    } else {
      min = Math.min(min, promotion.amount) * units;
      max = Math.max(max, promotion.amount) * units;
      currentMin = Math.min(currentMin, (promotion.current_amount ?? promotion.amount)) * units;
      currentMax = Math.max(currentMax, (promotion.current_amount ?? promotion.amount)) * units;
    }
  });

  if (currentMax === 0) {
    return (
      <>
        {max > 0 && (
        <>
          <UI.Span sc={{ deleted: true }}>
            {formatCurrency(max)}
          </UI.Span>
          {' '}
        </>
        )}
        {t('price_range.free')}
      </>
    );
  }

  if (currentMin === currentMax) {
    return (
      <>
        {min > currentMin && (
          <>
            <UI.Span sc={{ muted: true, deleted: true }}>
              {formatCurrency(min)}
            </UI.Span>
            {' '}
          </>
        )}
        {formatCurrency(currentMin)}
      </>
    );
  }

  return (
    <>
      {(min !== currentMin || max !== currentMax) && (
        <>
          <UI.Span sc={{ muted: true, deleted: true }}>
            {min !== currentMin && formatCurrency(min)}
            {min !== currentMin && max !== currentMax && ' - '}
            {max !== currentMax && formatCurrency(max)}
          </UI.Span>
          {' '}
        </>
      )}
      {formatCurrency(currentMin)}
      {' - '}
      {formatCurrency(currentMax)}
    </>
  );
};

export default PriceRange;
